import * as React from "react";
import type { SVGProps } from "react";
const SvgLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 11a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.528 21.352C6.342 19.25 3.45 15.464 3 11a9 9 0 0 1 18 0c-.446 4.43-3.67 8.19-7.552 10.302a3.15 3.15 0 0 1-2.92.05m2.203-1.368a1.65 1.65 0 0 1-1.53.027c-3.77-1.892-6.285-5.235-6.7-9.085a7.5 7.5 0 0 1 14.999 0c-.411 3.763-3.204 7.12-6.769 9.058"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLocation;
